<script setup lang="ts">
import { revenueApiImpl } from './useReportDesignServices'
import type { RouteRecordRaw } from 'vue-router'
import { RevenueReportPage } from '@myorg/report-lib'


import { ref, onMounted } from 'vue'

</script>

<template>
  <div class="flex flex-col gap-6 p-4 sm:p-6">

    <RevenueReportPage 
        :revenueApi="revenueApiImpl"
      />


  </div>
</template>
